var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('imputation-calendar',{attrs:{"contractLine":_vm.contractLine,"selectedDate":_vm.selectedDate,"readonly":_vm.readonly}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }